import PropTypes from 'prop-types';
import { useParams, useNavigate } from 'react-router';
import { MapIcon } from '@heroicons/react/24/outline';
import SystemsIcon from '@/assets/react-icons/md/SystemsIcon.svg';
import ListHeader from '../core/ListHeader';
import ListItemLink from '../core/ListItemLink';

const SystemAnalysesList = ({ systems }) => {
  const { projectId } = useParams();
  const navigate = useNavigate();

  const goToSystem = (event, system) => {
    event.preventDefault();
    navigate(`/projects/${projectId}/build/systems/${system.id}`);
  };

  return (
    <div className="divide-y divide-gray-75">
      <ListHeader title="Systems" icon={SystemsIcon} />
      {systems?.length > 0 ? (
        <ul className="p-2">
          {systems.map(system => (
            <li key={system.id} className="group/item relative">
              <ListItemLink to={`/projects/${projectId}/analysis/systems/${system.id}`}>
                <span className="truncate">{system.name}</span>
                <div className="group-hover/item:flex absolute right-5 hidden bg-canvas">
                  <MapIcon onClick={event => goToSystem(event, system)} className="h-5 w-5" />
                </div>
              </ListItemLink>
            </li>
          ))}
        </ul>
      ) : (
        <li className="p-2 text-sm">No systems found</li>
      )}
    </div>
  );
};

SystemAnalysesList.propTypes = {
  project: PropTypes.object,
  systems: PropTypes.arrayOf(PropTypes.object),
};

export default SystemAnalysesList;
